import { render, staticRenderFns } from "./ListPerfis.vue?vue&type=template&id=61570e24&"
import script from "./ListPerfis.vue?vue&type=script&lang=js&"
export * from "./ListPerfis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports